import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";

import { fetchCurrentUser } from "../../api/auth";
import type { AuthUser } from "../../stores/auth";
import { useAuthStore } from "../../stores/auth";

export function AuthBootstrap() {
  const setUser = useAuthStore((state) => state.setUser);

  const hasRequested = useRef(false);

  const {
    data,
    isError,
    isSuccess,
    refetch,
    status,
  } = useQuery<AuthUser>({
    queryKey: ["current-user"],
    queryFn: fetchCurrentUser,
    enabled: false,
    retry: false,
  });

  // Always attempt to fetch user on mount to check for session cookie
  // This handles both:
  // 1. Users with accessToken in localStorage (dev-login)
  // 2. Users with session cookie from OAuth (no accessToken in store yet)
  useEffect(() => {
    if (!hasRequested.current) {
      hasRequested.current = true;
      void refetch();
    }
  }, [refetch]);

  useEffect(() => {
    if (status === "success" || status === "error") {
      hasRequested.current = false;
    }
  }, [status]);

  useEffect(() => {
    if (isSuccess && data) {
      setUser(data);
    }
  }, [data, isSuccess, setUser]);

  useEffect(() => {
    if (isError) {
      setUser(null);
    }
  }, [isError, setUser]);

  return null;
}
